import { Injectable } from '@angular/core';
import Big from 'big.js';


@Injectable()
export class UtilService {

    constructor() { }

    /*
     * 阻止冒泡
     * IE下 window.event.cancelBubble=true
     * chrome和firef等用 e.stopPropagation()
     */
    stopPropagation(e) {
        window.event ? window.event.cancelBubble = true : e.stopPropagation();
    }

    object2params(obj) {
        if (obj) {
            return Object.keys(obj).map(x => {
                let val = obj[x];
                if (typeof val !== 'string') {
                    val = JSON.stringify(val);
                }
                return x + '=' + val;
            }).join('&');
        }
        return '';
    }

    // 添加BIG库访问器,不必单独引入big库
    get Big() {
        return Big;
    }

    // 使用big.js计算前判断数字或字符串是否合法运算值
    isBig(n, ...args) {
        const isValid = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
        args.push(n);
        return args.every(item => isValid.test(item += ''));
    }

    isObj(obj) {
        return obj === Object(obj);
    }

    routeTitleTransform(title) {
        return title.replace(/\s+/g, '-').toLowerCase().replace(/[^0-9a-z\-]+/g, '');
    }

    isSet(s, obj) {
        let n, arr, o;
        if (typeof s === 'string') {
            arr = s.split('.');
            o = obj;
            for (n = 0; n < arr.length; n += 1) {
                if (o[arr[n]] === undefined || o[arr[n]] === null) {
                    return false;
                } else {
                    o = o[arr[n]];
                }
            }
            return true;
        }
        throw new Error('Missing or invalid argument passed to isSet');
    }

    isEmpty(objs, ...args) {
        args.push(objs);
        function _isEmpty(obj) {
            switch (typeof obj) {
                case 'undefined':
                    return true;
                case 'string':
                    return (obj.trim().length === 0);
                case 'object':
                    if (Array.isArray(obj)) {
                        return (obj.length === 0);
                    } else if (obj === undefined) {
                        return true;
                    } else if (Object.keys(obj).length === 0) {
                        return true;
                    }
                    break;
                case 'number':
                    if (isNaN(obj)) {
                        return true;
                    }
                    break;
            }
        }
        return args.some(item => _isEmpty(item));
    }

    // 复制schema中选定的属性
    copyPropsBySchema(target, source, schema) {
        if (this.isObj(target) && this.isObj(source) && Array.isArray(schema)) {
            schema.forEach(function (prop) {
                if (typeof source[prop] !== 'undefined') {
                    target[prop] = source[prop];
                }
            });
            return target;
        } else {
            throw new Error('Missing or invalid argument passed to copyPropsBySchema');
        }
    }

    // 复制列表中对象选定的属性,返回新数组
    copyArrayBySchema(source, schema) {
        const result = [];
        const self = this;
        if (Array.isArray(source) && Array.isArray(schema)) {
            source.forEach(function (item) {
                const obj = {};
                self.copyPropsBySchema(obj, item, schema);
                result.push(obj);
            });
            return result;
        }
        throw new Error('Missing or invalid argument passed to copyArrayBySchema');
    }

    jsonPre(v) {
        if (!v) return '';
        const repl = v.toString()
            .replace(new RegExp('([\\\\])', 'g'), '\\\\')
            .replace(new RegExp('([\"])', 'g'), '\\"')
            .replace(new RegExp('([\'])', 'g'), '\\\'')
            .replace(new RegExp('([\|])', 'g'), '\\|');
        return encodeURIComponent(repl);
    }

    getLength(str) {
        let len = 0;
        for (let i = 0; i < str.length; i++) {
            if (str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
                len += 2;
            } else {
                len++;
            }
        }
        return len;
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/core/services/util.service.ts